module.exports = new __parcel__URL__("gradient-phrases-words.034c1fa3.jpg").toString();